/**
 * Terms of Use Page
 *
 * Public page rendering the full bQuest Terms of Service.
 * All legal text is an exact replica of the approved prototype.
 * Split into section components to stay under 300-line file limit.
 */

import { useDocumentHead } from '@/shared/hooks/useDocumentHead';
import { TermsOfUseStyles } from '../components/terms-of-use/TermsOfUseStyles';
import { TermsOfUseHeader } from '../components/terms-of-use/TermsOfUseHeader';
import { Sections1To3 } from '../components/terms-of-use/Sections1To3';
import { Sections4To5 } from '../components/terms-of-use/Sections4To5';
import { Sections6To8 } from '../components/terms-of-use/Sections6To8';
import { Sections9To12 } from '../components/terms-of-use/Sections9To12';
import { Sections13To16 } from '../components/terms-of-use/Sections13To16';
import { Section17Arbitration } from '../components/terms-of-use/Section17Arbitration';
import { Sections18To22, Section22ClosingText } from '../components/terms-of-use/Sections18To22';

export const TermsOfUsePage = () => {
  useDocumentHead({
    title: 'Terms of Service | The bQuest',
    description: 'bQuest Terms of Service — the agreement governing your use of the bQuest platform.',
  });

  return (
    <div className="bg-background" style={{ padding: '20px' }}>
      <TermsOfUseStyles />
      <TermsOfUseHeader />
      <ol id="l1">
        <Sections1To3 />
        <Sections4To5 />
        <Sections6To8 />
        <Sections9To12 />
        <Sections13To16 />
        <Section17Arbitration />
        <Sections18To22 />
      </ol>
      <Section22ClosingText />
    </div>
  );
};
